// Notification duration calculation constants
export const NOTIFICATION_DURATION = {
  BASE_SECONDS: 5,
  MINIMUM_SECONDS: 6,
  WORDS_PER_EXTRA_SECOND: 120,
}
